import React from "react"; 
import { Link } from "react-router-dom";    
import CreateDeliveryTermForm from "./CreateDeliveryForm";

const CreateDeliveryForm = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Create delivery Form</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/delivery-terms">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>delivery Terms</li>
          <li>Create delivery Form</li>
        </ul>
      </div> */}

      <CreateDeliveryTermForm /> 
    </> 
  );
};

export default CreateDeliveryForm;
